import React from 'react'

import { Link } from 'elements/text/Link'
import { Text } from 'elements/text/Text'
import { Alert, TAlertProps } from 'elements/ui/Alert'

import { PAGE } from 'routes/constants'

import type { TCommunity } from '../types'

export type TCommunityDraftExplanationProps = {
  community: TCommunity
  shortText?: boolean
} & TAlertProps

/**
 * ### CommunityDraftExplanation ###
 */
export const CommunityDraftExplanation: TFCC<TCommunityDraftExplanationProps> = ({
  community,
  shortText,
  ...otherProps
}) => (
  <Alert status="neutral" hideCloseButton {...otherProps}>
    <Text inline>
      {shortText
        ? 'trans:community:community.status.draft.explanation.short'
        : 'trans:community:community.status.draft.explanation.long'}
    </Text>
    {!shortText && (
      <Link
        to={{
          pathname: PAGE.COMMUNITY_EDIT,
          query: {
            communityId: community.id,
            communitySlug: community.slug,
          },
        }}
        color="blue"
        underline
        hoverColor="darkBlue"
      >
        <Text inline>trans:community:community.edit.edit</Text>
      </Link>
    )}
  </Alert>
)
